// Product data imported from SpareParts_Planner_PO_Focus.xlsx
// This serves as the initial data - in production, this would come from the database

export interface ProductItem {
  id: number;
  sku: string;
  name: string;
  description?: string;
  manufacturer: string;
  partNumber: string;
  parentId: number | null; // null for parent assemblies, parent id for components
  parentType: 'sensor_box' | 'control_box' | null; // for quick filtering
  qtyPerSystem: number; // Qty/System - static multiplier
  startOnHand: number;
  used: number;
  unitCost: number;
  type: 'assembly' | 'component';
}

// Parent Assemblies
export const SENSOR_BOX_ID = 1;
export const CONTROL_BOX_ID = 2;

export const products: ProductItem[] = [
  // ============================================
  // PARENT ASSEMBLIES
  // ============================================
  {
    id: SENSOR_BOX_ID,
    sku: 'ASSY-SENSOR-BOX',
    name: 'Sensor Box',
    description: 'Sensor Box Assembly',
    manufacturer: 'NVIDIA',
    partNumber: 'SENSOR-BOX-001',
    parentId: null,
    parentType: null,
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0, // Calculated from components
    type: 'assembly',
  },
  {
    id: CONTROL_BOX_ID,
    sku: 'ASSY-CTRL-BOX',
    name: 'Control Box',
    description: 'Control Box Assembly',
    manufacturer: 'NVIDIA',
    partNumber: 'CTRL-BOX-001',
    parentId: null,
    parentType: null,
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0, // Calculated from components
    type: 'assembly',
  },

  // ============================================
  // SENSOR BOX COMPONENTS
  // ============================================
  {
    id: 100,
    sku: 'HRS050-AF-20',
    name: 'CHILLER 5 KW',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 101,
    sku: 'HRS-CA004',
    name: 'POWER CABLE',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 102,
    sku: 'HRS-PF001-W005-H',
    name: '5 MICRON FILTER',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 103,
    sku: 'PF3W720-F04-FN-M',
    name: '2-16 FLOW SENSOR',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 104,
    sku: 'FC3W520-F04-A2N-NZ',
    name: 'FLOW CONTROLLER',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 2,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 105,
    sku: 'ZS-54-A',
    name: 'BRACKET FOR FLOW CONTROLLER',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 2,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 106,
    sku: 'PSE570-02-28N',
    name: 'PRESSURE SENSOR',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 2,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 107,
    sku: 'EX9-AC010-SSPS',
    name: 'CABLE FOR SENSORS & CONTROLLER 1M',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 6,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 108,
    sku: 'ZS-40-M12M8-A',
    name: 'M8 TO M12 CABLE',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 109,
    sku: 'KKA6P-04M-X95',
    name: 'KKA MALE 1/2 WITHOUT SEALANT',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 7,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 110,
    sku: 'KKA6S-04F',
    name: 'KKA FEMALE 1/2',
    manufacturer: 'SMC',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 7,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 111,
    sku: 'TF1205',
    name: 'Temperature transmitter',
    manufacturer: 'IFM',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 112,
    sku: 'N/A',
    name: 'METAL BOX',
    manufacturer: 'Kobi Technologies',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 113,
    sku: '12114000001',
    name: 'מסעף T נירוסטה 1/2',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 5,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 114,
    sku: '12090657',
    name: 'מקשר פלבם 122S מידה FF-SS 1/2',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 17,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 115,
    sku: '12252208',
    name: 'זווית פלבם 1/2 90 מעלות פ.פ',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 5,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 116,
    sku: '12080221',
    name: 'בושינג פלבם 110S מידה 1/2X1/4',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 3,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 117,
    sku: '5160546000004',
    name: 'ניפל אוליביה פלבם 316 קוטר 1/2',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 6,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 118,
    sku: '12251255',
    name: 'רקורד 1/2 BSP 150 316',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 3,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 119,
    sku: '5498520000002',
    name: 'בנד וזן אחת 17.8-21',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 6,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 120,
    sku: '5151519000007',
    name: 'מעבר קיר 1/2 נירוסטה',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 2,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 121,
    sku: '12252125',
    name: 'מופה 1/2',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 2,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 122,
    sku: '12251255-PLUG',
    name: 'פקק 1/2',
    description: 'נירוסטה 316 L',
    manufacturer: 'דיקסה',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 2,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 123,
    sku: '807-8-30CM',
    name: 'צינור פרקר EPDM 1/2 דגם 807-8, אורך 30 ס"מ',
    manufacturer: 'PARKER',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 124,
    sku: '807-8-90CM',
    name: 'צינור פרקר EPDM 1/2 דגם 807-8, אורך 90 ס"מ',
    manufacturer: 'PARKER',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 125,
    sku: '807-8-120CM',
    name: 'צינור פרקר EPDM 1/2 דגם 807-8, אורך 120 ס"מ',
    manufacturer: 'PARKER',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 126,
    sku: '90151251224021',
    name: 'דיסקה 40 מ"מ',
    manufacturer: 'סקופ',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 8,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 127,
    sku: '9010086040122M',
    name: 'בורג פיליפס M4',
    manufacturer: 'סקופ',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 10,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 128,
    sku: '10916040102',
    name: 'בורג אלן M10',
    manufacturer: 'סקופ',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 129,
    sku: '444442',
    name: 'מעבר כבלים אנטיגרון PG40',
    manufacturer: 'הדס',
    partNumber: '',
    parentId: SENSOR_BOX_ID,
    parentType: 'sensor_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },

  // ============================================
  // CONTROL BOX COMPONENTS
  // ============================================
  {
    id: 200,
    sku: 'CB-SAI-PANEL',
    name: 'SAI-8-F5P PUR 5M Panel to M12+5',
    manufacturer: 'Atka',
    partNumber: '',
    parentId: CONTROL_BOX_ID,
    parentType: 'control_box',
    qtyPerSystem: 1,
    startOnHand: 23,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 201,
    sku: 'CB-M12-CONNECTOR',
    name: 'SAIS-5/7 M12 Connector 5 Pin Male Straight',
    manufacturer: 'Atka',
    partNumber: '',
    parentId: CONTROL_BOX_ID,
    parentType: 'control_box',
    qtyPerSystem: 7,
    startOnHand: 173,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 202,
    sku: 'CB-RJ45-PANEL',
    name: 'IE-FCM-RJ45-C Panel Interface RJ45',
    manufacturer: 'Atka',
    partNumber: '',
    parentId: CONTROL_BOX_ID,
    parentType: 'control_box',
    qtyPerSystem: 1,
    startOnHand: 21,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
  {
    id: 203,
    sku: 'CB-RS232-CONN',
    name: 'RS232 Connector',
    manufacturer: 'TBD',
    partNumber: '',
    parentId: CONTROL_BOX_ID,
    parentType: 'control_box',
    qtyPerSystem: 1,
    startOnHand: 0,
    used: 0,
    unitCost: 0,
    type: 'component',
  },
];

// Helper functions
export function getProductById(id: number): ProductItem | undefined {
  return products.find(p => p.id === id);
}

export function getParentAssemblies(): ProductItem[] {
  return products.filter(p => p.type === 'assembly');
}

export function getComponentsByParent(parentId: number): ProductItem[] {
  return products.filter(p => p.parentId === parentId);
}

export function getSensorBoxComponents(): ProductItem[] {
  return products.filter(p => p.parentType === 'sensor_box');
}

export function getControlBoxComponents(): ProductItem[] {
  return products.filter(p => p.parentType === 'control_box');
}

// Calculate required quantity for given number of systems
export function calculateRequiredQty(product: ProductItem, systemsToOrder: number): number {
  return product.qtyPerSystem * systemsToOrder;
}

// Calculate shortage/surplus
export function calculateShortage(product: ProductItem, systemsToOrder: number): number {
  const required = calculateRequiredQty(product, systemsToOrder);
  return product.startOnHand - required;
}
